import React from "react";
import { CopyToClipboard } from "../../../../components";
import Link from "../../../../components/link/Link";
import { prepareHashNotificationText } from "./utils";

type HashRowProps = {
  hashName: string;
  hashValue?: string;
  to?: string;
};

const HashValue = ({ hashName, hashValue, to }: HashRowProps) =>
  to ? (
    <Link to={to} key={`hash-value-span-${hashName}`} className="hash-value">
      {hashValue}
    </Link>
  ) : (
    <span id={`hash-value-span-${hashName}`} className="hash-value">
      {hashValue}
    </span>
  );

const HashRow = ({ hashName, hashValue, to }: HashRowProps) => (
  <div className="hash-row">
    <span className="hash-name">{hashName} </span>
    <div className="hash-container">
      <div className="hash-wrapper">
        <CopyToClipboard
          value={hashValue}
          subjectText={prepareHashNotificationText(hashName)}
          className="me-10"
        />
        <HashValue hashName={hashName} hashValue={hashValue} to={to} />
      </div>
    </div>
  </div>
);

export default HashRow;
